import React, { Fragment } from 'react';
import { ButtonGroup, Button, Column, Dialog, Icon, Input, Loading, Select, Table, Uploader } from '@tencent/spaui';
import ABulkMiniDialog from '../../businessSetting/ABulkMiniDialog';
import { RPCFactory } from '../../../../utils/RequestUtil';
import { isShowLeadsSubSource } from '../../../../utils/whiteList';
import PrivilegeCode from '../../../../consts/PrivilegeCode';

const { FileUploader } = Uploader;
const multiHeader = { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' };

const dropdownData = [
  {
    value: 1,
    label: '标准字段',
  },
  {
    value: 3,
    label: '互动内容字段',
  },
  {
    value: 2,
    label: '表单字段',
  }
];

const ForwardType = {
  FORM: '表格填写',
  UPLOAD: 'Excel上传',
};

const standardFieldNameDropdownData = [
  {
    value: '',
    label: '请选择',
  },
  {
    value: 'pageId',
    label: '落地页ID(pageId)',
  },
  {
    value: 'campaignId',
    label: '推广计划ID(campaignId)',
  },
  {
    value: 'adId',
    label: '广告ID(adId)',
  },
  {
    value: 'actionSubType',
    label: '线索类型(actionSubType)',
  },
  {
    value: 'area',
    label: '所在地(area)',
  },
  {
    value: 'leadsSource',
    label: '线索来源(leadsSource)',
  },
  {
    value: 'componentId',
    label: '组件ID(componentId)',
  },
  {
    value: 'agencyId',
    label: '服务商ID(agencyId)',
  },
  {
    value: 'shopName',
    label: '门店名称(shopName)',
  },
  {
    value: 'shopAddress',
    label: '门店地址(shopAddress)',
  },
  {
    value: 'accountId',
    label: '归属账号ID(accountId)',
  },
];

export default class BusinessSettingPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: 1,
      leadsMappingList: [],
      leadsMappingListOne: {
        title: '',
        list: [{ bef: '', aft: '' }],
        bef: '',
        aft: '',
      },
      showAddConfig: false,
      showDelateConfig: false,
      showDetailConfig: false,
      eventTarget: null,

      // successMultiMark:false,
      failResultFile: '',
      successNum: '',
      failNum: '',
      // errorMultiMark:false,
      multiPercent: {},
      batchMarkLoadingShow: false,

      beforeBorderStyle: { border: '1px solid #dcdee3' },
      afterBorderStyle: { border: '1px solid #dcdee3' },
      beforeStandardValue: '',
      beforeBundleValue: '',
      beforeCustomQaValue: '',
      afterValue: '',

      successShow: false,
      failShow: false,
      failDetail: '',
      successShowDelete: false,
      failShowDelete: false,
      placement: 'right',
      deleteId: 0,
      editId: '',
      typeValue: 2,
      forwardType: 'FORM',
      isXuanjingUser: false,
    };
    this.batchMarkUploadedFile = '';
  }

  componentDidMount() {
    this.getLeadsMapping();
    // this.getNotification();
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    RPCFactory.account.check_whitelist(window.pageProps.uid, 'xuanjing_config').done((data) => {
      if (data) {
        this.setState({ isXuanjingUser: data });
      }
    });
  }
  handleResize = () => {
    if (window.innerWidth < 1472) {
      this.setState({
        placement: 'left',
      });
    } else {
      this.setState({
        placement: 'right',
      });
    }
  };

  getDynamicFieldNameDropdownData = () => [
    ...standardFieldNameDropdownData,
    ...((isShowLeadsSubSource || this.state.isXuanjingUser) ? [] : [
      {
        value: 'leadsSubSource',
        label: '二级线索来源(leadsSubSource)',
      },
    ]),
  ];
  showAddConfigDialog = (event) => {
    this.setState({
      leadsMappingListOne: {
        title: '',
        list: [{ bef: '', aft: '' }],
        bef: '',
        aft: '',
      },
      showAddConfig: true,
      model: 'add',
      beforeStandardValue: '',
      beforeBundleValue: '',
      beforeCustomQaValue: '',
      afterValue: '',
      typeValue: 2,
    });
  };

  setForwardType = (type) => {
    this.setState({ forwardType: type });
  };

  showEditConfigDialog = (event, data) => {
    this.getMappingDetailForId(data.mappingId);
    this.setState({
      showAddConfig: true,
      model: 'edit',
      beforeStandardValue: data.originalFieldType == 1 ? data.ida : '',
      beforeBundleValue: data.originalFieldType == 2 ? data.ida : '',
      beforeCustomQaValue: data.originalFieldType == 3 ? data.ida : '',
      afterValue: data.idb,
      editId: data.mappingId,
      uploadedExcelPath: null,
      typeValue: data.originalFieldType,
    });
  };

  handleDelateClose = () => {
    this.setState({
      showDelateConfig: false,
    });
  };
  handleDetailClose = () => {
    this.setState({
      showDetailConfig: false,
    });
  };
  columnOperatorRender = (type, name, value, data) => {
    if (type == 'head') {
      return <span>操作</span>;
    }
    return (
      <div>
        <a
          style={{ cursor: 'pointer' }}
          onClick={(e) => {
            this.showDetailConfigDialog(e, data.mappingId);
          }}
          className="a-link-primary"
        >
          详情
        </a>
        <a
          href={`/api/v1/leads_mapping/download?accountId=${window.pageProps.uid}&mappingId=${data.mappingId}&csrfToken=${window.pageProps.token}`}
          className="a-link-primary"
        >
          下载
        </a>
        {window.pageProps.privileges.includes(PrivilegeCode.LEADS_FIELD_MAPPING_EDIT.getCode()) && (
          <a
            style={{ cursor: 'pointer' }}
            onClick={(e) => {
              this.showDelateConfigDialog(e, data.mappingId);
            }}
            className="a-link-primary"
          >
            删除
          </a>
        )}
        {window.pageProps.privileges.includes(PrivilegeCode.LEADS_FIELD_MAPPING_EDIT.getCode()) && (
          <a
            style={{ cursor: 'pointer' }}
            onClick={(e) => {
              this.showEditConfigDialog(e, data);
            }}
            className="a-link-primary"
          >
            修改
          </a>
        )}
      </div>
    );
  };
  showDelateConfigDialog = (event, id) => {
    this.setState({
      showDelateConfig: true,
      deleteId: id,
      eventTarget: event.target,
    });
  };
  getMappingDetailForId = (id) => {
    RPCFactory.bussinessSetting
      .getLeadsMappingOne(id)
      .done((data) => {
        const list = Object.keys(data.mappingDetail).map((item) => ({ bef: item, aft: data.mappingDetail[item] }));
        this.setState({
          leadsMappingListOne: {
            title: data.originalFieldName,
            list,
            bef: data.originalFieldName,
            aft: data.mappedFieldName,
          },
        });
      })
      .fail((code, msg) => {
        alert(msg);
      });
  };
  onAdd = () => {
    const leadsMappingListOne = { ...this.state.leadsMappingListOne };
    leadsMappingListOne.list.push({ bef: '', aft: '' });
    this.setState({ leadsMappingListOne });
  };
  showDetailConfigDialog = (event, id) => {
    // RPCFactory.bussinessSetting
    //   .getLeadsMappingOne(id)
    //   .done((data) => {
    //     const list = Object.keys(data.mappingDetail).map((item) => ({ bef: item, aft: data.mappingDetail[item] }));
    //     this.setState({
    //       leadsMappingListOne: {
    //         title: data.originalFieldName,
    //         list,
    //         bef: data.originalFieldName,
    //         aft: data.mappedFieldName,
    //       },
    //     });
    //   })
    //   .fail((code, msg) => {
    //     alert(msg);
    //   });
    this.getMappingDetailForId(id);
    this.setState({
      showDetailConfig: true,
    });
  };
  downloadMappingOne = (event, id) => {
    RPCFactory.bussinessSetting.downloadMapping(id);
  };
  // 上传
  handleCloseMultiMark = () => {
    this.resetBorderStyle();
    this.batchMarkUploadedFile = '';
    this.setState({
      showAddConfig: false,
      beforeStandardValue: '',
      beforeBundleValue: '',
      beforeCustomQaValue: '',
      afterValue: '',
      multiPercent: {},
      forwardType: 'FORM',
      leadsMappingListOne: {
        title: '',
        list: [{ bef: '', aft: '' }],
        bef: '',
        aft: '',
      },
    });
  };
  resetBorderStyle = () => {
    this.setState({
      beforeBorderStyle: { border: '1px solid #dcdee3' },
      afterBorderStyle: { border: '1px solid #dcdee3' },
    });
  };
  delateSubmit = (event) => {
    RPCFactory.bussinessSetting
      .deleteMapping(this.state.deleteId)
      .done((data) => {
        // this.batchMarkUploadedFile = '';
        this.setState({
          showDelateConfig: false,
          successShowDelete: true,
          value: 1,
        });
        this.getLeadsMapping();
      })
      .fail((status, msg) => {
        this.setState({
          showDelateConfig: false,
          failShowDelete: true,
        });
      });
  };
  checkValidForm = () => {
    const { leadsMappingListOne, forwardType } = this.state;
    if (forwardType === 'UPLOAD') {
      return true;
    }
    let valid = true;
    leadsMappingListOne.list.forEach((ele, index) => {
      if (!ele.bef) {
        ele.befError = true;
        valid = false;
      }
      if (!ele.aft) {
        ele.aftError = true;
        valid = false;
      }
    });
    if (valid === false) {
      this.setState({ leadsMappingListOne: { ...leadsMappingListOne } });
      return false;
    }
    return true;
  };
  // 获取beforeValue
  getBeforeValue= () => {
    switch (this.state.typeValue){
      case 1:
        return this.state.beforeStandardValue;
      case 2:
        return this.state.beforeBundleValue;
      case 3:
        return this.state.beforeCustomQaValue;
      default:
        return '';
    }
  }
  handleSubmitMultiMark = () => {
    const valid = this.checkValidForm();
    if (!valid) {
      return;
    }
    const { forwardType, leadsMappingListOne } = this.state;
    const mappingDetail = {};
    leadsMappingListOne.list.map((ele) => {
      mappingDetail[ele.bef] = ele.aft;
    });
    if (this.state.beforeStandardValue == '' && this.state.beforeBundleValue == '' && this.state.beforeCustomQaValue == '') {
      this.setState({ beforeBorderStyle: { border: '1px solid #FF0000' } });
      return;
    }
    if (this.state.afterValue == '') {
      this.setState({ afterBorderStyle: { border: '1px solid #FF0000' } });
      return;
    }
    if (this.state.model == 'add') {
      this.setState({
        batchMarkLoadingShow: true,
      });
      const beforeValue = this.getBeforeValue();
      // uploadedExcelPath, originalFieldName, mappedFieldName, originalFieldType,mappingDetailUploadMethod, mappingDetail
      RPCFactory.bussinessSetting
        .confirmMappingExcel({
          uploadedExcelPath: this.batchMarkUploadedFile == '' ? null : this.batchMarkUploadedFile,
          originalFieldName: beforeValue,
          mappedFieldName: this.state.afterValue,
          originalFieldType: this.state.typeValue,
          mappingDetailUploadMethod: forwardType === 'FORM' ? 1 : 2,
          ...(forwardType === 'FORM' ? { mappingDetail } : null),
        })
        .done((data) => {
          this.batchMarkUploadedFile = '';
          this.setState({
            batchMarkLoadingShow: false,
            showAddConfig: false,
            beforeStandardValue: '',
            beforeBundleValue: '',
            beforeCustomQaValue: '',
            afterValue: '',
            multiPercent: {},
            successShow: true,
            forwardType: 'FORM',
            leadsMappingListOne: {
              title: '',
              list: [{ bef: '', aft: '' }],
              bef: '',
              aft: '',
            },
          });
          this.getLeadsMapping();
        })
        .fail((status, msg) => {
          this.setState({
            batchMarkLoadingShow: false,
            showAddConfig: false,
            beforeStandardValue: '',
            beforeBundleValue: '',
            beforeCustomQaValue: '',
            afterValue: '',
            multiPercent: {},
            failShow: true,
            failDetail: msg,
            forwardType: 'FORM',
            leadsMappingListOne: {
              title: '',
              list: [{ bef: '', aft: '' }],
              bef: '',
              aft: '',
            },
          });
        });
    }

    if (this.state.model == 'edit') {
      this.setState({
        batchMarkLoadingShow: true,
      });
      RPCFactory.bussinessSetting
        .update({
          mappingId: this.state.editId,
          uploadedExcelPath: this.batchMarkUploadedFile == '' ? null : this.batchMarkUploadedFile,
          originalFieldName: this.getBeforeValue(),
          mappedFieldName: this.state.afterValue,
          originalFieldType: this.state.typeValue,
          mappingDetailUploadMethod: forwardType === 'FORM' ? 1 : 2,
          ...(forwardType === 'FORM' ? { mappingDetail } : null),
        })
        .done((data) => {
          this.batchMarkUploadedFile = '';
          this.setState({
            batchMarkLoadingShow: false,
            showAddConfig: false,
            beforeStandardValue: '',
            beforeBundleValue: '',
            beforeCustomQaValue: '',
            afterValue: '',
            multiPercent: {},
            successShow: true,
          });
          this.getLeadsMapping();
        })
        .fail((status, msg) => {
          this.setState({
            batchMarkLoadingShow: false,
            showAddConfig: false,
            beforeStandardValue: '',
            beforeBundleValue: '',
            beforeCustomQaValue: '',
            afterValue: '',
            multiPercent: {},
            failShow: true,
            failDetail: msg,
          });
        });
    }
  };
  onChangeFormItem = ({ index, fieldName, value }) => {
    const leadsMappingListOne = { ...this.state.leadsMappingListOne };
    leadsMappingListOne.list[index][fieldName] = value;
    this.setState({ leadsMappingListOne });
  };
  onDeleteFormItem = (index) => {
    const leadsMappingListOne = { ...this.state.leadsMappingListOne };
    leadsMappingListOne.list.splice(index, 1);
    this.setState({ leadsMappingListOne });
  };
  successClose = () => {
    this.setState({
      successShow: false,
    });
  };
  failClose = () => {
    this.setState({
      failShow: false,
    });
  };
  successCloseDelete = () => {
    this.setState({
      successShowDelete: false,
    });
  };
  failCloseDelete = () => {
    this.setState({
      failShowDelete: false,
    });
  };
  handleMultiMarkComplete = (response, fileTarget) => {
    const { data } = response;
    if (response.code == 0) {
      this.batchMarkUploadedFile = response.data;
      this.setState({
        multiPercent: {
          url: 'http://www.placehold.it/300x300',
          message: '',
          status: 'success',
        },
      });
    } else {
      this.batchMarkUploadedFile = '';
      this.setState({
        multiPercent: {
          url: 'http://www.placehold.it/300x300',
          message: response.msg,
          status: 'fail',
        },
      });
    }
  };
  handleBeforeChange = (event, value) => {
    this.resetBorderStyle();
    this.setState({
      beforeBundleValue: value,
    });
  };

  handleCustomQaChange = (event, value) => {
    this.resetBorderStyle();
    this.setState({
      beforeCustomQaValue: value,
    });
  };
  handleAfterChange = (event, value) => {
    this.resetBorderStyle();
    this.setState({
      afterValue: value,
    });
  };

  getLeadsMapping() {
    RPCFactory.bussinessSetting.getAllLeadsMapping().done((data) => {
      this.setState({
        leadsMappingList: data.entities.map((item) => ({
          ida: item.originalFieldName,
          idb: item.mappedFieldName,
          idc: item.createdTime,
          mappingId: item.id,
          originalFieldType: item.originalFieldType,
        })),
        totalSize: data.size,
      });
    });
  }

  getEmptyTable = () => (
    <div className="datalist empty">
      <i className="empty-bg"></i>
      <p>暂无配置数据</p>
    </div>
  );

  render() {
    const multiMarkUpLoad = `/api/v1/leads_mapping/upload_excel?accountId=${window.pageProps.uid}&csrfToken=${window.pageProps.token}`;
    const { forwardType, leadsMappingListOne } = this.state;
    const setCellStyle = (type, name, value, rowIndex, colIndex, data) => {
      let result = {};

      if (type === 'head') {
        result = {
          backgroundColor: '#F1F4F9',
          fontSize: '14px',
          height: '40px',
          borderBottomWidth: '1px',
          width: '419px',
          paddingLeft: '20px',
        };
      } else if (type === 'data') {
        result = {
          fontSize: '14px',
          height: '40px',
          paddingLeft: '20px',
        };
      }
      return result;
    };

    return (
      <Fragment>
        {window.pageProps.privileges.includes(PrivilegeCode.LEADS_FIELD_MAPPING_EDIT.getCode()) && (
          <div className="panel-hd-right">
            <Button displayType="primary" onClick={this.showAddConfigDialog}>
              <Icon type="add" />
              新建配置
            </Button>
          </div>
        )}
        {this.state.leadsMappingList.length > 0 ? (
          <div className="datalist">
            <Table data={this.state.leadsMappingList} onColumnWidthChange={this.handleColumnWidthChange}>
              <Column name="ida">字段名</Column>
              <Column name="idb">转换后字段名</Column>
              <Column name="idc">创建时间</Column>
              <Column name="idd" render={this.columnOperatorRender}>
                操作
              </Column>
            </Table>
          </div>
        ) : (
          this.getEmptyTable()
        )}
        <Dialog
          backdrop
          show={this.state.showAddConfig}
          onClose={this.handleCloseMultiMark}
          onSubmit={this.handleSubmitMultiMark}
          onCancel={this.handleCloseMultiMark}
          style={{ width: '660px' }}
          type="normal"
          title={this.state.model == 'edit' ? '修改配置' : '新增配置'}
          className="modal-field-trans-new"
        >
          <div className="field-trans-new">
            <p className="setting-desc">
              为解决销售和广告投放环节中，对某些字段命名和参数值设置不同，可设置字段转换规则。
            </p>
            <p className="setting-example">
              如：表单项设置“经销商名称”，但实际销售跟进中使用“专营店号”，可在此处进行映射关系配置。
            </p>
            <div className="field-trans-form">
              <div className="trans">
                <div className="bef">
                  <p className="name">字段名</p>
                  <div className="trans">
                    <div className="trans-select">
                      <Select
                        placeholder="表单字段"
                        data={dropdownData}
                        value={this.state.typeValue}
                        onChange={(e, value) => {
                          this.setState({ typeValue: value });
                        }}
                      />
                    </div>
                    {this.state.typeValue == 1 ? (
                      <div className="trans-select" style={{ width: '100%' }}>
                        <Select
                          placeholder="请选择"
                          data={this.getDynamicFieldNameDropdownData()}
                          value={this.state.beforeStandardValue}
                          onChange={(e, value) => {
                            this.setState({ beforeStandardValue: value });
                          }}
                        />
                      </div>
                    ) : this.state.typeValue == 2 ?(
                      <Input
                        value={this.state.beforeBundleValue}
                        style={this.state.beforeBorderStyle}
                        placeholder="请输入需要转换的字段名"
                        onChange={this.handleBeforeChange}
                      />
                    ): (<Input
                      value={this.state.beforeCustomQaValue}
                      style={this.state.beforeBorderStyle}
                      placeholder="请输入需要转换的字段名"
                      onChange={this.handleCustomQaChange}
                    />)}
                  </div>
                </div>
                <span className="center-wd">转换为</span>
                <div className="aft">
                  <p className="name">转换后字段名</p>
                  <Input
                    value={this.state.afterValue}
                    style={this.state.afterBorderStyle}
                    placeholder="请输入转换后的字段名"
                    onChange={this.handleAfterChange}
                  />
                </div>
              </div>
            </div>
            <div className="mapping-area-title">
              <p className="mapping-area-title-p">配置字段值映射关系</p>
            </div>
            <ButtonGroup
              data={Object.keys(ForwardType).map((key) => ({
                value: key,
                label: ForwardType[key],
              }))}
              // disabled={props.disabled || disabledAllField}
              value={forwardType}
              onChange={(event, value) => {
                this.setForwardType(value);
              }}
            />
            {forwardType === 'FORM' && (
              <div className="info-des-sec">
                <div className="config-li">
                  <div className="trans-bef">
                    <p>字段值</p>
                  </div>
                  <div className="trans"></div>
                  <div className="trans-aft">
                    <p>转换后字段值</p>
                  </div>
                </div>
                {leadsMappingListOne.list &&
                  leadsMappingListOne.list.map((ele, index) => (
                    <div className="config-li">
                      <Input
                        className="trans-bef"
                        value={!(ele.befError && ele.bef == '') ? ele.bef : ''}
                        valid={!ele.befError}
                        onChange={(e, value) => {
                          this.onChangeFormItem({
                            index,
                            fieldName: 'bef',
                            value,
                          });
                        }}
                        status={ele.befError && ele.bef.length === 0 ? 'error' : ''}
                      />
                      <div className="trans">对应</div>
                      <Input
                        className="trans-aft"
                        value={!(ele.aftError && ele.aft == '') ? ele.aft : ''}
                        valid={!ele.aftError}
                        status={ele.aftError && ele.aft.length === 0 ? 'error' : ''}
                        onChange={(e, value) => {
                          this.onChangeFormItem({
                            index,
                            fieldName: 'aft',
                            value,
                          });
                        }}
                      ></Input>
                      <div className="close-wraper">
                        <i
                          className="icon icon-close"
                          onClick={(e) => {
                            this.onDeleteFormItem(index);
                          }}
                        ></i>
                      </div>
                    </div>
                  ))}
                <a
                  className="add-item"
                  onClick={() => {
                    this.onAdd();
                  }}
                >
                  ＋添加转换字段值
                </a>
              </div>
            )}
            {forwardType === 'UPLOAD' && (
              <div className="uparea">
                <p className="name">上传配置表</p>
                <p className="desc">
                  1、下载<a href="/assets/doc/leads_mapping_template.xlsx">配置表模板</a>，按模板要求补充配置字段；
                  <br />
                  2、特别注意：若选择标准字段中的xxxxxx，请使用配置表模板中的枚举值进行配置，否则不生效；配置表原始字段值可为空。
                </p>
                {this.state.model == 'edit' ? <p className="name">如需要更新配置表，请重新上传</p> : null}
                <FileUploader
                  className="multi-mark-upload"
                  accept="*/*"
                  name="uploadedExcel"
                  style={{ marginTop: '10px' }}
                  headers={multiHeader}
                  url={multiMarkUpLoad}
                  value={this.state.multiPercent}
                  onDelete={this.handleMultiMarkDelete}
                  onComplete={this.handleMultiMarkComplete}
                  uploadText={this.state.model == 'edit' ? '重新上传' : '本地上传'}
                ></FileUploader>
                <div style={{ marginTop: '10px', color: 'red', textAlign: 'center' }}>
                  {this.state.multiPercent.message}
                </div>
              </div>
            )}
          </div>
        </Dialog>
        <Dialog
          show={this.state.successShow}
          time={2000}
          timeCallback={this.successClose}
          type="tip"
          iconType="success"
        >
          {this.state.model == 'edit' ? '修改成功，信息已导入' : '新建成功，信息已导入'}
        </Dialog>
        <Dialog show={this.state.failShow} time={2000} timeCallback={this.failClose} type="tip" iconType="error">
          {this.state.failDetail}
        </Dialog>
        <Dialog
          show={this.state.successShowDelete}
          time={2000}
          timeCallback={this.successCloseDelete}
          type="tip"
          iconType="success"
        >
          删除成功
        </Dialog>
        <Dialog
          show={this.state.failShowDelete}
          time={2000}
          timeCallback={this.failCloseDelete}
          type="tip"
          iconType="error"
        >
          删除失败
        </Dialog>
        <Loading show={this.state.batchMarkLoadingShow} type="page" />
        <ABulkMiniDialog
          show={this.state.showDelateConfig}
          eventTarget={this.state.eventTarget}
          onSubmit={this.delateSubmit}
          onCancel={this.handleDelateClose}
          eventTargetPlacement={this.state.placement}
          width={'280px'}
          title={''}
        >
          <div className="confirmbox confirmbox-del">
            <div className="content">
              <p className="tt">确定删除该配置？</p>
              <p className="des">删除后不可恢复，平台不再自动转换销售数据。</p>
            </div>
          </div>
        </ABulkMiniDialog>
        <Dialog
          backdrop
          hideFooter
          type="normal"
          style={{ maxHeight: '700px' }}
          show={this.state.showDetailConfig}
          onClose={this.handleDetailClose}
          onSubmit={this.handleDetailClose}
          onCancel={this.handleDetailClose}
          title={
            this.state.leadsMappingListOne.title ? `${this.state.leadsMappingListOne.title}转换配置表` : '转换配置表'
          }
        >
          <div>
            <Table data={this.state.leadsMappingListOne.list} setCellStyle={setCellStyle} fixedRows={20}>
              <Column name="bef">{this.state.leadsMappingListOne.bef}</Column>
              <Column name="aft">{this.state.leadsMappingListOne.aft}</Column>
            </Table>
          </div>
        </Dialog>
      </Fragment>
    );
  }
}
